var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M12 12h8m-8 7h8M12 5h8M6.5 12a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0-7a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0 14a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgList;